import DqOverview from './src/overview'

/* istanbul ignore next */
DqOverview.install = function (Vue) {
  Vue.component(DqOverview.name, DqOverview)
}

export default DqOverview



// WEBPACK FOOTER //
// ./src/dq-ui/packages/overview/overview.js